import firebase from 'firebase';

export const Action = {
  Create: "CREATE",
  Update: "UPDATE",
  Delete: "DELETE",
  Unlock: "UNLOCK",
  Denied: "DENIED",
  Call: "CALL",
};

export class Log {
  constructor(props = {}) {
    let {
      id = "",
      userId = "",
      propertyId = "",
      passcodeId = "",
      timestamp = firebase.database.ServerValue.TIMESTAMP,
      action = "",
      model = "",
      message = "",
      data = {},
      previousData = {},
    } = props;

    this.id = id;
    this.userId = userId;
    this.propertyId = propertyId;
    this.passcodeId = passcodeId;
    this.timestamp = timestamp;
    this.action = action;
    this.model = model;
    this.message = message;
    this.data = data;
    this.previousData = previousData;
  }
}

export default Log;


// WEBPACK FOOTER //
// ./src/models/Log.js